import { useEffect, useMemo, useState } from 'react'
import * as store from '@store'
import DocumentSearchRunsheetsTable from './DocumentSearchRunsheetsTable'
import { Link } from 'react-router-dom'
import RunsheetTab from '@/components/tract/Runsheet/RunsheetTab'
import { useSearchParams } from 'react-router-dom'
import { useWireValue } from '@forminator/react-wire'
import { getRunsheetDocsByTab } from '@/components/tract/Runsheet/Runsheet.lib'

/**
 * 
 * @param {CollectionViewModel} vm
 * @returns {JSX.Element}
 * @constructor
 */
const CollectionRunsheetsView = ({ vm }) => {
    
    const [expandView, setExpandView] = useState(true)
    
    const [searchParams ] = useSearchParams()
    
    const runsheet = useWireValue(store.currentRunsheet)
    const tabs = useWireValue(store.runsheetTabs)
    
    const activeTab = useMemo(() => searchParams.get('activeTab'), [searchParams])
    const currentTab = useMemo(() => tabs.find(t => t.id === activeTab) || tabs[0], [tabs, activeTab])
    
    const runsheetDocs = useMemo(() =>
        getRunsheetDocsByTab(currentTab, runsheet),
    [runsheet, currentTab])
    
    useEffect(() => {
        if (vm.selectedRunsheet) setExpandView(true)
    }, [vm.selectedRunsheet])
    
    return (
        <div className="w-full runsheets-list relative">
            <div className="pb-[200px]">
                <div className="flex items-center justify-between px-3
                    sticky left-[0] top-[0] h-[64px] bg-base-100 runsheet-header">
                    <div className="flex flex-col">
                        <span className="text-base">Runsheet: 
                            <Link
                                className="pl-2 underline font-bold"
                                data-test-id="CollectionRunsheetsView-RunsheetNameLink"
                                to={`/runsheet/${vm.selectedRunsheet.id}`}>
                                {vm.selectedRunsheet.name}
                            </Link>
                        </span>
                        <div>
                            <span>
                                Total:
                                {' '}
                                {runsheetDocs?.length || '0'}
                            </span>
                            {' / '}
                            <span>Selected: {vm.markedRunsheetDocs?.length || '0'}</span>
                        </div>
                    </div>
                    
                    <div className="mr-2">
                        <div>
                            {/*
                                @todo should reenable whenever its working again
                                <button className="mr-2 btn btn-primary btn-md">
                                    Export Runsheet
                                </button> */}
                            <button
                                className="btn btn-primary btn-sm"
                                data-test-id="CollectionRunsheetsView-RemoveDocumentsButton"
                                disabled={
                                    !runsheetDocs?.length ||
                                    !vm.markedRunsheetDocs?.length ||
                                    vm.isRemovingFromRunsheet}
                                onClick={vm.removeRunsheetDocument}>
                                {vm.isRemovingFromRunsheet && (<span className="loading loading-spinner loading-xs"/>)}
                                Remove Documents
                            </button>
                            <button
                                className="ml-2 btn btn-secondary btn-sm"
                                onClick={() => {
                                    vm.setSelectedRunsheet(null)
                                    vm.setMarkedRunsheetDocs([])
                                    vm.setSearchParams(prev => {
                                        prev.delete('openRunsheetId')
                                        prev.delete('activeTab')
                                        return prev
                                    })
                                }}>
                                    Close Runsheet
                            </button>
                        </div>
                    </div>
                
                </div>
                
                <div style={{ height: expandView ? 'auto': '0px', overflow: expandView ? 'initial' : 'hidden' }}>
                    
                    <div className="pt-0 pl-0 pr-0 ml-0 position sticky">
                        <DocumentSearchRunsheetsTable
                            markedRunsheetDocs={vm.markedRunsheetDocs}
                            setMarkedRunsheetDocs={vm.setMarkedRunsheetDocs} />
                    </div>
                
                </div>
            </div>
            <div className="fixed bottom-0 left-0 right-0">
                <RunsheetTab runsheetId={vm.selectedRunsheet.id} canEdit={false} />
            </div>
        </div>
    )
}

export default CollectionRunsheetsView
